import { Box, Grid, Typography } from '@mui/material'
import React from 'react'
import {useTheme} from '@mui/material';
import { tokens } from '../../theme';

  import { SiMicrosoftsqlserver } from "react-icons/si";

import {
  DiJavascript1,

  DiNodejs,
  DiMongodb,
  DiPython,
  DiGit,
 
} from "react-icons/di";
import Tool from './Tool'
import { SiExpress } from "react-icons/si";
  import { FaReact } from "react-icons/fa";

  import { FaJava } from "react-icons/fa";
  import { TbBrandRedux } from "react-icons/tb";

import Github from './Github';
export const Skill = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
  return (
    <Box>
        <Grid container spacing={2}>
            <Grid xs={12}>
                <Box display='flex' flexDirection='row' justifyContent='center' marginTop={10}>
                    <Typography variant='h2' fontWeight='bold'>PROFESSIONAL <strong className="main-name" style={{ color: colors.blueAccent[400] }}>SKILLS</strong></Typography>
                </Box>
                <Box display='flex' marginTop={10} marginLeft={10} marginRight={10}>
                      <Grid xs={2} display='flex' justifyContent='center' className="tech-icons">
                          <FaJava ></FaJava>
                      </Grid>
                      <Grid xs={2} display='flex' justifyContent='center' className="tech-icons">
                          <FaReact></FaReact>
                      </Grid>
                      <Grid xs={2} display='flex' justifyContent='center' className="tech-icons">
                          <SiMicrosoftsqlserver></SiMicrosoftsqlserver>
                      </Grid>
                      <Grid xs={2} display='flex' justifyContent='center' className="tech-icons">
                          <TbBrandRedux></TbBrandRedux>
                      </Grid>
                      <Grid xs={2} display='flex' justifyContent='center' className="tech-icons">
                          <DiNodejs></DiNodejs>
                      </Grid>
                      <Grid xs={2} display='flex' justifyContent='center' className="tech-icons">
                          <DiMongodb></DiMongodb>
                      </Grid>
                </Box>
                <Box display='flex' justifyContent='center' marginTop={10} marginLeft={10} marginRight={10} marginBottom={10}>
                      <Grid xs={2} display='flex' justifyContent='center' className="tech-icons">
                          <DiJavascript1 ></DiJavascript1>
                      </Grid>
                      <Grid xs={2} display='flex' justifyContent='center' className="tech-icons">
                          <DiGit></DiGit>
                      </Grid>
                      <Grid xs={2} display='flex' justifyContent='center' className="tech-icons">
                          <SiExpress></SiExpress>
                      </Grid>
                      <Grid xs={2} display='flex' justifyContent='center' className="tech-icons">
                          <DiPython></DiPython>
                      </Grid>
                      
                </Box>
                <Box display='flex' justifyContent='center' marginTop={5} marginLeft={10} marginRight={10} marginBottom={10}>
                    <Tool></Tool>
                </Box>
                <Box display='flex' flexDirection='row' justifyContent='center' marginTop={5} marginLeft={10} marginRight={10} marginBottom={10}>
                    <Github></Github>
                </Box>
            </Grid>
        </Grid>
    </Box>
  )
}